const ACCESS_TOKEN = process.env.TOKEN_HEADER

let isAddListener = false

export default {
  namespaced: true,
  state: () => ({
    token: localStorage.getItem(ACCESS_TOKEN),
    id: 0,
    realName: null,
    permissions: [],
    navList: [],
    roleId: 0,
    orgId: null
  }),
  getters: {
    token: state => state.token,
    id: state => state.id,
    realName: state => state.realName,
    permissions: state => state.permissions,
    navList: state => state.navList,
    roleId: state => state.roleId,
    orgId: state => state.orgId
  },
  mutations: {
    setAccountInfo (state, profile) {
      if (profile) {
        state.id = profile.id
        state.realName = profile.realName
        state.permissions = profile.permissions
        state.roleId = profile.roleId
        state.orgId = profile.orgId
      } else {
        state.id = 0
        state.realName = null
        state.permissions = []
        state.roleId = 0
        state.orgId = null
      }
    },
    setToken (state, token) {
      if (token) {
        localStorage.setItem(ACCESS_TOKEN, state.token = token)
      }
    },
    removeToken (state) {
      state.token = null
      localStorage.removeItem(ACCESS_TOKEN)
    },
    setNavList (state, navList) {
      let tmpMap = {}
      let tmpList = [...navList].sort((a, b) => a.routeIndex - b.routeIndex)
      let roots = []

      for (; tmpList.length > 0;) {
        let tmpNav = tmpList.shift()
        let name = tmpNav.name
        let parentName = tmpNav.parent
        let nav = {
          name,
          path: tmpNav.path,
          ...tmpNav.meta
        }
        let children = tmpNav.children

        if (Array.isArray(children) && children.length > 0) {
          nav.children = []
          tmpMap[name] = nav
          tmpList.push(...[...children].sort((a, b) => a.routeIndex - b.routeIndex))
        }

        if (parentName === null) {
          roots.push(nav)
        } else {
          tmpMap[parentName].children.push(nav)
        }
      }

      state.navList = Object.freeze(roots)
    }
  },
  actions: {
    addListener ({commit}) {
      if (isAddListener) {
        return
      }

      isAddListener = true

      window.addEventListener('storage', event => {
        if (event.key === ACCESS_TOKEN) {
          let newValue = event.newValue

          if (newValue === null) {
            commit('removeToken')
          } else {
            commit('setToken', newValue)
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Profile.js